import { getWeekDescriptionFromWeekAbv } from './get-week-desc-from-week-abv'

export const getFeedBestBetHeading = (weekAbv: string) => {
  const week = getWeekDescriptionFromWeekAbv(weekAbv, 'feed-best-bets')
  if (week) return `${week} Best Bets`
  return 'Best Bets'
}
